import React from 'react';

import './CalendarMonth.scss';

interface CalendarMonthProps extends React.PropsWithChildren {}
export const CalendarMonth = (props: CalendarMonthProps) => {
  return <div className='calendar-month'>{props.children}</div>;
};
